/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportJobView } from '../../models/api-response-import-job-view';

export interface CommitImport$Params {
  'x-api-requestId'?: string;
  reference: string;
}

export function commitImport(http: HttpClient, rootUrl: string, params: CommitImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
  const rb = new RequestBuilder(rootUrl, commitImport.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportJobView>;
    })
  );
}

commitImport.PATH = '/v1/api/ui/imports/{reference}/commit';
